export default __webpack_public_path__ + "static/media/reward-blue.729ff642.svg";